import axiosInstance from "./AxiosInstance";

const JobActivityService = {
  getPendingCount: async () => {
    try {
      const response = await axiosInstance.get("/v1/job-activities/pending-count");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getJobActivities: async (page = 1, limit = 10, search = "", status = "ALL") => {
    try {
      let params = {};
      if (page && limit) {
        params = {
          ...params,
          page,
          limit,
        };
      }
      if (search) {
        params = {
          ...params,
          search,
        };
      }

      params = {
        ...params,
        status,
      };
      
      const response = await axiosInstance.get("/v1/job-activities", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getJobActivityById: async (id) => {
    try {
      const response = await axiosInstance.get(`/v1/job-activity/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  approveJobActivity: async (id, isApproved) => {
    try {
      const response = await axiosInstance.patch(
        `/v1/job-activity/${id}/approve`,
        { isApproved }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getJobActivityByJobId: async (jobId) => {
    try {
      const response = await axiosInstance.get(`/v1/job-activity/job/${jobId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default JobActivityService; 